import { render, staticRenderFns } from "./Menu_association.vue?vue&type=template&id=10097220&scoped=true&slot%3Aheader=true"
import script from "./Menu_association.vue?vue&type=script&lang=js"
export * from "./Menu_association.vue?vue&type=script&lang=js"
import style0 from "./Menu_association.vue?vue&type=style&index=0&id=10097220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10097220",
  null
  
)

export default component.exports